import { EnterpretLogoFull } from '@modules/common/components/EnterpretLogoFull';
import { Button, Stack, Typography } from '@mui/material';
import { TenantOption } from 'generated/graphql';
import { TenantSelectionOption } from './TenantSelectionOption';
import { TenantSelectionViewFooter } from './TenantSelectionViewFooter';

export interface TenantSelectionErrorState {
  tenantSlug: string;
  error: string;
}

interface TenantSelectionViewProps {
  tenants: TenantOption[];
  onTenantSelection: (slug: string) => void;
  errorState?: TenantSelectionErrorState;
}

export const TenantSelectionView = ({
  tenants,
  onTenantSelection,
  errorState,
}: TenantSelectionViewProps) => {
  const onLogoutClick = () => {
    window.location.href = '/logout';
  };

  return (
    <Stack height="100vh" justifyContent="space-between">
      <Stack justifyContent="center" flex={1} spacing={4} mt={10}>
        <Stack spacing={4} alignItems="center">
          <EnterpretLogoFull width="165" height="35" />
          <Typography>Select the instance you want to access</Typography>
          <Stack spacing={2}>
            {tenants.map((tenant) => {
              const hasErrorMessage = tenant.slug === errorState?.tenantSlug;
              return (
                <TenantSelectionOption
                  key={tenant.id}
                  tenant={tenant}
                  onTenantSelection={onTenantSelection}
                  errorMessage={hasErrorMessage ? errorState.error : undefined}
                />
              );
            })}
          </Stack>
        </Stack>
        <Stack alignItems="center">
          <Button variant="text" onClick={onLogoutClick}>
            Logout
          </Button>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="center" py={6}>
        <TenantSelectionViewFooter />
      </Stack>
    </Stack>
  );
};
